import script from "./FundPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./FundPayment.vue?vue&type=script&setup=true&lang=js"

import "./FundPayment.vue?vue&type=style&index=0&id=0c2cc4b8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2cc4b8"]])

export default __exports__